module.exports = __webpack_public_path__ + "img/plugin.1034ac1.png";